import React from 'react';
import { motion } from 'framer-motion';

const Philosophy = () => {
  return (
    <section id="philosophy" className="py-24 bg-slate-800/30">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">
            Our Philosophy
          </h2>
          <div className="w-16 h-px bg-amber-400 mx-auto" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="space-y-6"
          >
            <blockquote className="text-2xl md:text-3xl font-serif italic text-slate-200 leading-relaxed">
              "True transformation occurs not through the application of standard methodologies, 
              but through the synthesis of deep understanding and innovative thinking."
            </blockquote>
            <cite className="text-slate-400 text-sm tracking-wide">
              — Founding Principles, Oxford Holdings
            </cite>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.4 }}
            className="space-y-6"
          >
            <p className="text-slate-300 leading-relaxed text-lg">
              We operate at the intersection of academic rigor and practical application, 
              where theoretical frameworks meet real-world complexity. Our methodology 
              is rooted in systems thinking and behavioral economics.
            </p>
            <p className="text-slate-300 leading-relaxed text-lg">
              Each engagement is a bespoke exploration, designed to unlock the latent 
              potential within your organization's unique ecosystem.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;